export const variableChartOptions = {
    chart: {
        type: 'variablepie',
        height: 230,
        width: 250,
        backgroundColor: 'transparent',
    },

    title: {
        text: undefined,
    },
    credits: {
        enabled: false,
    },
    tooltip: {
        headerFormat: undefined,
        formatter:function(){
            return `${this.point.options.name} :  <b>${((this.point.options.y * 100) / this.point.options.total).toFixed(1)}%</b> (${this.point.y})`
        }
    },
    series: [{
        minPointSize: 10,
        innerSize: '75%',
        zMin: 0,
        name: '',
        data: [],
        dataLabels: {
            enabled: false,
        },
    }],
};